import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from } from '@helpers/media';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import styled, { css } from 'styled-components';
const Container = styled.section `
  ${setCssVar('sectionMargin', '32px')};
  ${setCssVar('sitePadding', '18px')};
  ${setCssVar('siteWidth', '100%')};

  @media ${from(Device.TabletLarge)} {
    ${setCssVar('sectionMargin', '64px')};
  }

  @media ${from(Device.DesktopLarge)} {
    ${setCssVar('sitePadding', '18px')};
    ${setCssVar('siteWidth', '1640px')};
  }

  ${(props) => css `
    /* Set default spacing. */
    ${setSpacing(cssVar('sectionMargin'), props.spacing, 'both')}

    /* Override based on flush prop. */
    ${props.flush && setSpacing('0px', props.spacing, props.flush)}
  `}
`;
const ScrollAnchor = styled.div `
  scroll-margin: calc(var(--headerHeight) + var(--headerReducedOffset) + 32px) 0 0;
`;
const StyledSiteWide = styled(SiteWide) ``;
const SectionWrapperStyles = {
    Container,
    SiteWide: StyledSiteWide,
    ScrollAnchor,
};
export default SectionWrapperStyles;
function setSpacing(value, type, side) {
    let output = '';
    if (side === 'none') {
        return;
    }
    if (side === 'both') {
        output = `
      ${type}-top: ${value};
      ${type}-bottom: ${value};
    `;
    }
    else {
        output = `
      ${type}-${side}: ${value};
    `;
    }
    return css `
    ${output}
  `;
}
